import React, { useState, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { inpS } from "../../constants/styles";
import Ic from "../common/Ic";

function ChatBox({ pid, sender }) {
  const { t, h, msgs, setMsgs, addNotif, tens, props } = useContext(Ctx); const [tx, setTx] = useState(""); const fm = msgs.filter(m => m.pid === pid);
  // Server hardens m.fr to the literal strings "landlord" or "tenant"
  // (derived from JWT role so the value can't be spoofed). The sender
  // prop here is "ll" for the landlord side and the tenant's id for the
  // tenant side — neither matches the stored value, which is why every
  // bubble used to render on the left. Translate sender into the same
  // role string the server stores so "is this mine?" is a real check.
  const myRole = sender === "ll" ? "landlord" : "tenant";
  const isMine = (m) => m.fr === myRole;
  const doSend = () => {
    if (!tx) return;
    const newMsg = { id: `g${Date.now()}`, pid, fr: myRole, tx, tm: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) };
    setMsgs([...msgs, newMsg]);
    api.sendMessage(newMsg);
    if (sender === "ll") {
      const prop = props.find(p => p.id === pid); const tenant = tens.find(tt => tt.id === prop?.tid);
      if (tenant) addNotif("tenant", tenant.id, `New message from Landlord: "${tx.slice(0, 40)}${tx.length > 40 ? "..." : ""}"`, "chat");
    } else {
      addNotif("landlord", null, `New message from ${tens.find(tt => tt.id === sender)?.name || "Tenant"}: "${tx.slice(0, 40)}${tx.length > 40 ? "..." : ""}"`, `chat:${pid}`);
    }
    setTx("");
  };
  return <><div style={{ minHeight: 200 }}>
    {fm.length === 0 && <div style={{ color: h.sc, textAlign: "center", padding: 40, fontSize: 13 }}>{t.noMsgYet}</div>}
    {fm.map(m => {
      const mine = isMine(m);
      return <div key={m.id} style={{ display: "flex", justifyContent: mine ? "flex-end" : "flex-start", marginBottom: 8 }}>
        <div style={{
          maxWidth: "75%", padding: "10px 14px", borderRadius: 14,
          background: mine ? h.ac : h.cd,
          color: mine ? "#fff" : h.tx,
          border: mine ? "none" : `1px solid ${h.bd}`,
          // Slight tail-style asymmetry so left/right are immediately
          // legible at a glance (matches WhatsApp/iMessage convention).
          borderBottomRightRadius: mine ? 4 : 14,
          borderBottomLeftRadius: mine ? 14 : 4,
        }}>
          <div style={{ fontSize: 13 }}>{m.tx}</div>
          <div style={{ color: mine ? "rgba(255,255,255,0.75)" : h.sc, fontSize: 10, marginTop: 4 }}>{m.tm}</div>
        </div>
      </div>;
    })}
  </div>
    <div style={{ display: "flex", gap: 8, marginTop: 12, position: "sticky", bottom: 74, background: h.bg, padding: "8px 0" }}>
      <input value={tx} onChange={e => setTx(e.target.value)} placeholder={t.typeMsg} style={{ ...inpS(h), flex: 1, marginBottom: 0 }} onKeyDown={e => { if (e.key === "Enter") doSend(); }} />
      <button onClick={doSend} style={{ background: h.ac, border: "none", borderRadius: 10, padding: "0 14px", cursor: "pointer", display: "flex", alignItems: "center" }}><Ic n="send" s={18} c="#fff" /></button>
    </div></>;
}

export default ChatBox;
